import * as React from 'react';
import { PlayerDataProps } from '@screens/players/types/player.data.props';
import PlayerPaymentsList from '@screens/players/player.details.tabs/payments/player.payments.list';
import PlayerPaymentsBonus from '@screens/players/player.details.tabs/payments/player.payments.bonus';
import PlayerPaymentsReverse from './player.payments.reverse';

const PlayerPayments = ({ player }: PlayerDataProps) => {
  return (
    <>
      <PlayerPaymentsReverse player={player} />
      <PlayerPaymentsList player={player} />
      <PlayerPaymentsBonus player={player} />
    </>
  );
};

export default PlayerPayments;
